import vars from '../helpers';
import video from './video';
import menu from './menu';
import aos from './aos';
import scroll from './scroll';
import intro from './intro';
import footer from './footer';

const init = () => {
	const tl = gsap.timeline();
	const $siteContainer = $('.js-site-container');
	const $introItems = $('.js-intro-item');

	if (vars.isMobile()) {
		tl.from($siteContainer, {
			onStart() {
				$siteContainer.removeClass('is-hidden');
				$introItems.removeClass('is-hidden');
				video.init();
				$('[data-aos]').removeAttr('data-aos');
				// $('.js-line').removeClass('is-hidden');
			},
			onComplete() {
				menu.init();
				scroll.init();
				footer.init();
			},
			autoAlpha: 0,
			duration: 1,
			clearProps: 'all',
		}, 1);
	} else {
		const $word1 = $('.js-intro-title-word-1');
		const $word2 = $('.js-intro-title-word-2');
		const $word3 = $('.js-intro-title-word-3');
		// const $line1 = $('.js-intro-line-1');
		// const $line2 = $('.js-intro-line-2');
		// const $line3 = $('.js-intro-line-3');
		const $video = $('.js-intro-video');
		// const $videoBorder = $('.js-intro-video-border');
		// const $videoButton = $('.js-intro-video-button');
		const $image = $('.js-intro-image');
		// const $figure1 = $('.js-intro-figure-1');
		// const $figure2 = $('.js-intro-figure-2');
		const $text = $('.js-intro-text');

		let deltaY;

		if (window.innerWidth > 1800) {
			deltaY = `${Math.floor(25 * 100 / window.innerWidth / 1366 * 1800 * 100) / 100}px`;
		} else {
			deltaY = `${Math.floor(25 * 100 / window.innerWidth * 100) / 100}vw`;
		}

		tl
			.from($siteContainer, {
				onStart() {
					$siteContainer.removeClass('is-hidden');
				},
				onComplete() {
					intro.init();
					menu.init();
					video.init();
					scroll.init();
					aos.init();
				},
				autoAlpha: 0,
				duration: 1,
				clearProps: 'all',
			}, 1.5)
			// .from($line1, {
			// 	left: '-100%',
			// 	duration: 1,
			// }, 2)
			// .from($line2, {
			// 	right: '-100%',
			// 	duration: 1,
			// }, 2)
			// .from($line3, {
			// 	left: '-100%',
			// 	duration: 1,
			// }, 2)
			// .from($videoBorder, {
			// 	opacity: 0,
			// 	y: deltaY,
			// 	duration: 1,
			// }, 2.5)
			.from($video, {
				opacity: 0,
				y: deltaY,
				duration: 1,
			}, 3)
			// .from($videoButton, {
			// 	opacity: 0,
			// 	duration: 1,
			// }, 4)
			// .from($figure2, {
			// 	opacity: 0,
			// 	duration: 1,
			// 	y: deltaY,
			// }, 3.5)
			.from([$word1, $word2, $word3], {
				opacity: 0,
				duration: 1,
				y: deltaY,
			}, 3.5)
			.from($image, {
				opacity: 0,
				duration: 1,
				y: deltaY,
			}, 4)
			.from($text, {
				opacity: 0,
				duration: 1,
				y: deltaY,
				clearProps: 'all',
			}, 4.5)
			// .from($figure1, {
			// 	opacity: 0,
			// 	duration: 1,
			// 	y: deltaY,
			// }, 4.5)
		;
	}
};

export default {
	init,
};
